import {
  NumberField as AriaNumberField,
  Input,
  type NumberFieldProps as AriaNumberFieldProps,
} from "react-aria-components";
import { tv } from "tailwind-variants";
import { focusRing } from "../utils/focusRing";
import { composeTailwindRenderProps } from "../utils/utils";

const input = tv({
  extend: focusRing,
  base: "flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50",
  variants: {
    isInvalid: {
      true: "border-destructive",
    },
  },
});

export interface NumberFieldProps extends AriaNumberFieldProps {
  label?: string;
  description?: string;
  errorMessage?: string;
  placeholder?: string;
}

export function NumberField({
  label,
  description,
  errorMessage,
  placeholder,
  ...props
}: NumberFieldProps) {
  return (
    <AriaNumberField
      {...props}
      className={composeTailwindRenderProps(props.className, "group flex flex-col gap-1")}
    >
      {label && (
        <label className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
          {label}
        </label>
      )}
      <Input className={input} placeholder={placeholder} />
      {description && <div className="text-muted-foreground text-sm">{description}</div>}
      {errorMessage && <div className="text-destructive text-sm">{errorMessage}</div>}
    </AriaNumberField>
  );
}
